// The ONLY place the AI agent talks to a backend (design-system.md §9.3).
//
// send({ text, context, catalog }) resolves to an array of typed blocks:
//   { type: 'text', markdown }                       assistant prose (**bold**, *italic*)
//   { type: 'products', items: [productId] }          one product card per id
//   { type: 'carousel', title, items: [productId] }   horizontal product carousel
//   { type: 'variantPicker', productId }              size picker + Confirm inside the chat
//   { type: 'chips', items: [string] }                suggestion chips (tapping one sends it)
//   { type: 'showMore', label, state }                row that opens /search with `state`
//   { type: 'action', name: 'goto', to }              navigate (e.g. to checkout)
//
// Today it uses the scripted mock. To ship the real agent, POST to the API instead, e.g.
//   const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/ai/chat`, { text, context });
//   return data.blocks;
// The UI does not need to change.
import { respond, greeting as mockGreeting } from './mockAgent';

export const send = ({ text, context, catalog }) => respond({ text, context, catalog });

export const greeting = (context) => mockGreeting(context);
